$(function() {
    var nav_pos = $(".page-nav").offset().top;
var nav_height = $(".page-nav").outerHeight();
$(window).scroll(function () {
    if ($(this).scrollTop() > nav_pos) {
        $("body").css("padding-top", nav_height);
        $(".page-nav").addClass("is-fixed");
    } else {
        $("body").css("padding-top", 0);
        $(".page-nav").removeClass("is-fixed");
    }
});
});


$(function () {
  $('.accordion-contents dt').click(function() {
    $(this).next('dd').slideToggle('fast'),
    $(this).toggleClass("open");
  });
});


  window.addEventListener("DOMContentLoaded", () => {
  // サムネイルのスライダー
  const thumbnail = new Swiper(".thumbnail-1", {
    freeMode: true,
    slidesPerView: 5,
    spaceBetween: 8,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  // メインのスライダー
  const slider = new Swiper(".slider-1", {
    thumbs: {
      swiper: thumbnail,
    },
    breakpoints: {
			 //768px以上の場合
			/*768: {
				
			}*/
		},
    effect: 'fade',
    speed: 1000,
    spaceBetween: 10,
    loop: true, 
    /*autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },*/
  });
});
  
  window.addEventListener("DOMContentLoaded", () => {
  // サムネイルのスライダー
  const thumbnail = new Swiper(".thumbnail-2", {
    freeMode: true,
    slidesPerView: 5,
    spaceBetween: 8,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  // メインのスライダー
  const slider = new Swiper(".slider-2", {
    thumbs: {
      swiper: thumbnail,
    },
    effect: 'fade',
    speed: 1000,
    spaceBetween: 10,
    loop: true, 
  });
});

  window.addEventListener("DOMContentLoaded", () => {
  // サムネイルのスライダー
  const thumbnail = new Swiper(".thumbnail-3", {
    freeMode: true,
    slidesPerView: 5,
    spaceBetween: 8,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  // メインのスライダー
  const slider = new Swiper(".slider-3", {
    thumbs: {
      swiper: thumbnail,
    },
    effect: 'fade',
    speed: 1000,
    spaceBetween: 10,
    loop: true, 
  });
});

  window.addEventListener("DOMContentLoaded", () => {
  // サムネイルのスライダー
  const thumbnail = new Swiper(".thumbnail-4", {
    freeMode: true,
    slidesPerView: 5,
    spaceBetween: 8,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  // メインのスライダー
  const slider = new Swiper(".slider-4", {
    thumbs: {
      swiper: thumbnail,
    },
    effect: 'fade',
    speed: 1000,
    spaceBetween: 10,
    loop: true, 
  });
});

  window.addEventListener("DOMContentLoaded", () => {
  // サムネイルのスライダー
  const thumbnail = new Swiper(".thumbnail-5", {
    freeMode: true,
    slidesPerView: 5,
    spaceBetween: 8,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  // メインのスライダー
  const slider = new Swiper(".slider-5", {
    thumbs: {
      swiper: thumbnail,
    },
    effect: 'fade',
    speed: 1000,
    spaceBetween: 10,
    loop: true, 
  });
});

  window.addEventListener("DOMContentLoaded", () => {
  // サムネイルのスライダー
  const thumbnail = new Swiper(".thumbnail-6", {
    freeMode: true,
    slidesPerView: 5,
    spaceBetween: 8,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  // メインのスライダー
  const slider = new Swiper(".slider-6", {
    thumbs: {
      swiper: thumbnail,
    },
    effect: 'fade',
    speed: 1000,
    spaceBetween: 10,
    loop: true, 
  });
});
